import React, { useState } from "react";

const BuyTezPopup = ({ isOpen, onClose }) => {
  const [amount, setAmount] = useState("");
  const [tezAmount, setTezAmount] = useState(0);
  const [crypto, setCrypto] = useState({ name: "ꜩ", symbol: "ꜩ" });
  const [showCryptoList, setShowCryptoList] = useState(false);
  const exchangeRate = 1.214; // Example rate: 1 USD = 1.214 ꜩ

  // List of cryptocurrencies (for dropdown selection)
  const cryptoOptions = [
    { name: "ꜩ", symbol: "ꜩ" },
    { name: "Bitcoin", symbol: "BTC" },
    { name: "Ethereum", symbol: "ETH" },
    { name: "Binance Coin", symbol: "BNB" },
    { name: "Polygon", symbol: "MATIC" },
    { name: "Arbitrum", symbol: "ARB" },
  ];

  // Handle amount input change
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    setTezAmount((e.target.value * exchangeRate).toFixed(2));
  };

  // Select cryptocurrency from the dropdown
  const handleCryptoSelection = (selectedCrypto) => {
    setCrypto(selectedCrypto);
    setShowCryptoList(false);
  };

  // Redirect to a payment processor (MoonPay/Transak)
  const handleTopUp = () => {
    window.open(
      `https://ramp.network/buy?defaultAsset=${crypto.symbol}&fiatValue=${amount}`,
      "_blank"
    );
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay p-28">
      <div className="modal-content">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
        >
          ✖
        </button>

        <h2 className="text-xl font-bold text-center mb-4">Buy Tez</h2>

        {/* Input: Pay in USD */}
        <div className="mb-4">
          <label className="text-gray-600 text-sm">You Pay</label>
          <div className="flex justify-between border p-2 rounded">
            <input
              type="number"
              value={amount}
              onChange={handleAmountChange}
              className="w-full outline-none"
              placeholder="Enter USD amount"
            />
            <span className="text-gray-500">USD</span>
          </div>
        </div>

        {/* Output: Get ꜩ */}
        <div className="mb-4 relative">
          <label className="text-gray-600 text-sm">You Get</label>
          <div
            className="flex justify-between border p-2 rounded cursor-pointer"
            onClick={() => setShowCryptoList(!showCryptoList)}
          >
            <span>{tezAmount}</span>
            <span className="text-gray-500 flex items-center">
              {crypto.symbol} ▼
            </span>
          </div>

          {/* Cryptocurrency Selection Dropdown */}
          {showCryptoList && (
            <div className="absolute top-full left-0 w-full bg-white border rounded mt-2 shadow-lg z-10">
              {cryptoOptions.map((option) => (
                <div
                  key={option.symbol}
                  className="p-2 hover:bg-gray-200 cursor-pointer flex justify-between"
                  onClick={() => handleCryptoSelection(option)}
                >
                  <span>{option.name}</span>
                  <span className="text-gray-500">{option.symbol}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Continue Button */}
        <button
          onClick={handleTopUp}
          className="w-full bg-black text-white py-2 rounded disabled:bg-gray-400"
          disabled={!amount}
        >
          Continue
        </button>

        {/* Payment Methods */}
        <div className="text-center mt-2 text-sm text-gray-500">
          <span>VISA & Mastercard accepted</span>
        </div>
      </div>
    </div>
  );
};

export default BuyTezPopup;
